<template>
  <section class="section">
    <form @submit.prevent="validateBeforeSubmit">
      <div class="container">
        <div class="columns">
          <div class="column is-10">
            <h1 class="title green">
              <span v-if="order.id != null && order.id !== 0 && order.id !== -1"> {{ order.primaryCode }}</span>
              <span v-else>{{ title }}</span> - {{ patient.name }} -
              <span v-if="patient.shopData">{{ patient.shopData.name }}</span> -
              {{ $translate(currentStatus) | capitalize }}
            </h1>
          </div>
          <div class="column has-text-right">
            <b-field grouped position="is-right">
              <b-field>
                <a
                  v-if="order.id !== null && order.id !== 0 && order.id !== -1"
                  type="button"
                  class="button is-danger"
                  :disabled="isDeletableBool || disabledbool"
                  @click="
                    if (!isDeletableBool && !disabledbool) {
                      deleteOccurence(order.id)
                    }
                  "
                >
                  <b-icon icon="delete-outline" />
                </a>
              </b-field>
              <b-field>
                <b-dropdown aria-role="list" position="is-bottom-left">
                  <button
                    slot="trigger"
                    type="button"
                    class="button is-primary"
                    :disabled="isSaveDisabled || disabledbool"
                  >
                    <b-icon icon="content-save-outline" />
                  </button>

                  <b-dropdown-item class="pointercursor" :disabled="disabledbool" @click="validateBeforeSubmit(true)">
                    {{ $translate('save') | capitalize }}
                  </b-dropdown-item>
                  <b-dropdown-item class="pointercursor" @click="tryvalidate()">
                    {{ $translate('check') | capitalize }}
                  </b-dropdown-item>

                  <hr class="dropdown-divider" />

                  <b-dropdown-item class="pointercursor" :disabled="disabledbool" @click="trysave('invord')">
                    {{ $translate('save_envo') | capitalize }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    class="pointercursor"
                    :disabled="disabledbool || $store.getters.user.userInfo.level == '1'"
                    @click="trysave('sendord')"
                  >
                    {{ $translate('save_sended') | capitalize }}
                  </b-dropdown-item>

                  <hr class="dropdown-divider" />
                  <b-dropdown-item class="pointercursor" @click="printOrderFunction()">
                    {{ $translate('print') | capitalize }}
                  </b-dropdown-item>
                  <hr v-if="!order.company.simplifiedOrder" class="dropdown-divider" />
                  <b-dropdown-item v-if="!order.company.simplifiedOrder" class="pointercursor" @click="exportJson()">
                    {{ $translate('export') | capitalize }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="!order.company.simplifiedOrder"
                    class="pointercursor"
                    :disabled="sendingToMercurio"
                    @click="sendToMercurio()"
                  >
                    {{ $translate('send_to_mercurio') | capitalize }}
                  </b-dropdown-item>
                </b-dropdown>
              </b-field>
            </b-field>
          </div>
        </div>
        <hr />

        <b-tabs v-model="activeTab" position="is-left" class="blocks">
          <b-tab-item>
            <template slot="header">
              <b-icon icon="information-outline" />
              <span> {{ $translate('generalInfo') }}</span>
            </template>
            <div class="container">
              <OrderGeneralInfo
                :order.sync="order"
                :config="config"
                :shape-filter="shapeFilter"
                :has-secondary-prev="hasSecondaryPrev"
                :patient.sync="patient"
                :pathologiesbool.sync="pathologiesbool"
                :status.sync="$status[order.module]"
                :disabledbool.sync="disabledbool"
                :current-status.sync="currentStatus"
                :is-save-disabled.sync="isSaveDisabled"
                :language.sync="language"
                :is-simplified.sync="order.company.simplifiedOrder"
                @onChangeShapeFilter="changeShapeFilter"
                @onChangeSecondaryPrev="changeSecondaryPrev"
                @onChangeSeasonFilter="changeSeasonFilter"
                @onPairSwitched="onPairSwitched"
              />
              <hr class="green" />
              <OrderTypologyFits
                ref="OrderTypologyFits"
                :order.sync="order"
                :bdictionary.sync="bdictionary_insole"
                :b-dictionary-name.sync="bDictionaryNameInsole"
                :ddictionary.sync="ddictionary_insole"
                :d-dictionary-name.sync="dDictionaryNameInsole"
                :disabledbool.sync="disabledbool"
                :is-simplified.sync="order.company.simplifiedOrder"
                @updateParent="updateChild()"
              />
            </div>
          </b-tab-item>
          <b-tab-item v-if="order.pair !== 'right'">
            <template slot="header">
              <b-icon icon="book-open-outline" />
              <span> {{ $translate('model') | capitalize }} SX</span>
            </template>
            <div class="container">
              <OrderModelInsole
                ref="OrderModelSx"
                side="sx"
                :mod.sync="order.mod_sx"
                :order.sync="order"
                :config="config"
                :catalog-model.sync="catalog.model"
                :disabledbool.sync="disabledbool"
                :is-save-disabled.sync="isSaveDisabled"
                :is-simplified.sync="order.company.simplifiedOrder"
                :available-insole-base="availableInsoleBase"
                :available-insole-cover="availableInsoleCover"
                :available-insole-fill="availableInsoleFill"
                :available-inserts="availableInserts"
                @materialChanged="payload => syncInsoleMaterial('sx', payload)"
              />
            </div>
          </b-tab-item>
          <b-tab-item v-if="order.pair !== 'left'">
            <template slot="header">
              <b-icon icon="book-open-outline" />
              <span> {{ $translate('model') | capitalize }} DX</span>
            </template>
            <div class="container">
              <OrderModelInsole
                ref="OrderModelDx"
                side="dx"
                :mod.sync="order.mod_dx"
                :order.sync="order"
                :config="config"
                :catalog-model.sync="catalog.model"
                :disabledbool.sync="disabledbool"
                :is-save-disabled.sync="isSaveDisabled"
                :is-simplified.sync="order.company.simplifiedOrder"
                :available-insole-base="availableInsoleBase"
                :available-insole-cover="availableInsoleCover"
                :available-insole-fill="availableInsoleFill"
                :available-inserts="availableInserts"
                @materialChanged="payload => syncInsoleMaterial('dx', payload)"
              />
            </div>
          </b-tab-item>
          <b-tab-item>
            <template slot="header">
              <b-icon icon="view-dashboard-outline" />
              <span> {{ $translate('measure_text') | capitalize }}</span>
            </template>
            <MeasurementsInsoleForm
              ref="Measurements"
              :order.sync="order"
              :disabledbool.sync="disabledbool"
              :missingattachment.sync="missingattachment"
              :arraytodelete.sync="arraytodelete"
            />
          </b-tab-item>
        </b-tabs>
      </div>
    </form>

    <PrintOrder :print-order-bool.sync="printOrderBool" :orders.sync="printOrders" />

    <b-loading :is-full-page="true" :active.sync="isSaveDisabled" :can-cancel="false" />
  </section>
</template>

<script>
import '@/helpers/mixins/variables/ordertype'
import '@/helpers/mixins/variables/deliverytype'

import orderTools from '@/helpers/mixins/orderTools'
import materialTools from '@/helpers/mixins/materialTools'
import permissionMixin from '@/helpers/mixins/permissionMixin'
import keyWordGenerator from '@/helpers/mixins/keyWordGenerator.js'
import exportTools from '@/helpers/mixins/exportTools'

import OrderGeneralInfo from './components/OrderGeneralInfo'
import OrderTypologyFits from './components/OrderTypologyFits.vue'
import OrderModelInsole from './components/OrderModelInsole.vue'
import MeasurementsInsoleForm from './components/MeasurementsInsoleForm.vue'
import PrintOrder from './components/PrintOrder'

import firebase from 'firebase'
import { cloneDeep, isEqual } from 'lodash'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  name: 'OrderFormInsole',
  components: {
    OrderGeneralInfo,
    OrderTypologyFits,
    OrderModelInsole,
    MeasurementsInsoleForm,
    PrintOrder,
  },
  mixins: [orderTools, materialTools, permissionMixin, keyWordGenerator, exportTools],
  props: {
    orderId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      catalog: {},
      disabledbool: false,
      sendingToMercurio: false,
      currentStatus: null,
      pathologiesbool: null,
      bdictionary_insole: null,
      bDictionaryNameInsole: '',
      ddictionary_insole: null,
      dDictionaryNameInsole: '',
      loadingData: false,
      printOrderBool: false,
      printOrders: null,
      id: -1,
      tempid: -1,
      patientId: -1,
      patient: {},
      title: 'Form Ordine',
      activeTab: 0,
      isSaveDisabled: false,
      isDeletableBool: true,
      shapeFilter: null,
      hasSecondaryPrev: false,
      availableInsoleBase: [],
      availableInsoleCover: [],
      availableInsoleFill: [],
      availableInserts: [],
      missingattachment: false,
      arraytoupload: {},
      arraytodelete: {},
      lastSavedOrder: {},

      order: {
        id: null,
        statusOrder: 'compord',
        send_date: null,
        pair: 'both',
        primaryCode: null,
        catalogType: null,
        shoeType: null,
        seasontag: null,
        orderTypeMainRifMat: null,
        orderType: null,
        orderTypeMain: null,
        orderTypeVariant: null,
        orderTypeSubVariant: null,
        deliverySelected: null,
        deliverySelectedSub: null,
        hasDigitalArchive: false,
        patientId: null,
        creationDate: null,
        lastModificationDate: null,
        pathologiesLeft: [],
        pathologiesRight: [],
        materialprod: [],
        materialacc: [],
        module: 'insole',
        isPrinted: false,
        mod: null,
        mod_sx: {},
        mod_dx: {},
        footmeasurements: {},
        attachment: {},
        attachmentflag: {},
        note: null,
        company: {
          simplifiedOrder: false,
        },
      },
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    config() {
      return this.$moduleConfiguration[this.order.module]
    },
  },
  watch: {
    order: {
      deep: true,
      handler() {
        this.isDeletableBool = this.isTransitionDoable(this.currentStatus, 'deletedord', this.order) === false
        this.$forceUpdate()
      },
    },
  },
  async mounted() {
    this.isSaveDisabled = true
    this.disabledbool = !this.$route.params.view

    this.$validator.extend('notnull', value => {
      return !(value === '' || value === undefined)
    })

    this.$validator.extend('unique', async value => {
      let temparray = []
      await this.$db
        .collection('orders')
        .where('primaryCode', '==', value)
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            if (doc.id !== this.id) {
              temparray.push(doc.data().primaryCode)
            }
          })
        })

      return !temparray.includes(value)
    })

    this.patientId = this.$route.params.patientId !== undefined ? this.$route.params.patientId : -1
    this.id = this.orderId ? this.orderId : -1

    if (this.patientId !== -1) {
      this.order.patientId = this.patientId
    } else {
      if (this.id === -1) {
        await this.$router.push({ name: 'patients' })
      }
    }

    this.loadingData = true
    if (this.id !== -1) {
      await this.$db
        .collection('orders')
        .doc(this.id)
        .get()
        .then(doc => {
          if (!doc.exists) {
            this.lastSavedOrder = cloneDeep(this.order)
            this.$router.push({ name: 'orders' })
          }
          let orderData = doc.data()
          orderData.mod = orderData.mod || {}
          if (!orderData.pair) orderData.pair = 'both'
          if (Object.keys(orderData.materialacc).length === 0) orderData.materialacc = []
          if (Object.keys(orderData.materialprod).length === 0) orderData.materialprod = []
          this.order = orderData
          if (this.order.attachment == null) {
            this.order.attachment = {}
          }
          if (this.order.attachmentflag == null) {
            this.order.attachmentflag = {}
          }
        })

      if (!this.order.mod_sx || Object.keys(this.order.mod_sx).length === 0) {
        this.$set(this.order, 'mod_sx', this.order.mod ? cloneDeep(this.order.mod) : {})
      }
      if (!this.order.mod_dx || Object.keys(this.order.mod_dx).length === 0) {
        this.$set(this.order, 'mod_dx', this.order.mod ? cloneDeep(this.order.mod) : {})
      }

      this.patientId = this.order.patientId
      await this.loadPatientStatfromOrder()
    } else {
      await this.loadPatientStat()
      if (this.$route.params.startingorderType) {
        this.order.orderType = this.$route.params.startingorderType
      }
    }

    if (this.order.tec == null) {
      this.order.tec = this.$store.getters.user.userInfo.username
    }

    this.order.patient = this.patient
    this.currentStatus = this.order.statusOrder

    if (!this.catalog || !this.catalog.type) {
      this.$buefy.notification.open({
        duration: 3000,
        message: this.$translate('catalog_missing'),
        type: 'is-danger',
      })
      this.lastSavedOrder = cloneDeep(this.order)
      await this.$router.push({ name: 'orders' })
      return
    }

    await this.getMaterialArrayFiltered(this.availableInsoleBase, this.config.materials.Moi, this.catalog)
    await this.getMaterialArrayFiltered(this.availableInsoleCover, this.config.materials.Ric_plan, this.catalog)
    await this.getMaterialArrayFiltered(this.availableInsoleFill, this.config.materials.Rie_plan, this.catalog)
    await this.getMaterialArrayFiltered(this.availableInserts, this.config.materials.Ins, this.catalog)

    await this.$nextTick()
    if (this.$refs.OrderModelSx) {
      await this.$refs.OrderModelSx.updateAfterload()
    }
    if (this.$refs.OrderModelDx) {
      await this.$refs.OrderModelDx.updateAfterload()
    }
    this.$refs.Measurements.checkValue()

    this.lastSavedOrder = cloneDeep(this.order)
    this.loadingData = false
    this.$forceUpdate()
  },
  methods: {
    nullifyUndefined(obj) {
      if (Array.isArray(obj)) {
        obj.forEach((v, i) => {
          if (v === undefined) obj[i] = null
          else if (v && typeof v === 'object') this.nullifyUndefined(v)
        })
      } else if (obj && typeof obj === 'object') {
        Object.keys(obj).forEach(k => {
          if (obj[k] === undefined) obj[k] = null
          else if (obj[k] && typeof obj[k] === 'object') this.nullifyUndefined(obj[k])
        })
      }
    },
    exportJson() {
      this.exportFormOrderJson(this.order, this.id)
    },
    async sendToMercurio() {
      if (this.sendingToMercurio) return
      this.sendingToMercurio = true
      await this.sendFormOrderToMercurio(this.order, this.id)
      this.sendingToMercurio = false
    },
    printOrderFunction() {
      this.printOrders = []
      this.printOrders.push(this.order)
      this.printOrderBool = true
    },
    onPairSwitched(pair) {
      if (pair === 'left') {
        this.order.mod_dx = {}
        return
      }
      if (pair === 'right') {
        this.order.mod_sx = {}
        return
      }
      const syncKeys = ['insoleBaseMat', 'insoleBaseVar', 'insoleCoverMat', 'insoleCoverVar', 'insoleFillMat', 'insoleFillVar']
      const seedInto = (target, source) => {
        syncKeys.forEach(key => this.$set(target, key, source[key] != null ? source[key] : null))
      }
      const sxHasMaterials = this.order.mod_sx && this.order.mod_sx.insoleBaseMat != null
      const dxHasMaterials = this.order.mod_dx && this.order.mod_dx.insoleBaseMat != null
      if (sxHasMaterials && !dxHasMaterials) {
        seedInto(this.order.mod_dx, this.order.mod_sx)
      } else if (dxHasMaterials && !sxHasMaterials) {
        seedInto(this.order.mod_sx, this.order.mod_dx)
      }
      this.$nextTick(() => {
        if (this.$refs.OrderModelSx && this.$refs.OrderModelSx.$refs.insole) {
          this.$refs.OrderModelSx.$refs.insole.updateAfterload()
        }
        if (this.$refs.OrderModelDx && this.$refs.OrderModelDx.$refs.insole) {
          this.$refs.OrderModelDx.$refs.insole.updateAfterload()
        }
      })
    },
    syncInsoleMaterial(fromSide, payload) {
      const syncKeys = ['insoleBaseMat', 'insoleBaseVar', 'insoleCoverMat', 'insoleCoverVar', 'insoleFillMat', 'insoleFillVar']
      if (!syncKeys.includes(payload.key)) return
      const target = fromSide === 'sx' ? this.order.mod_dx : this.order.mod_sx
      if (!target) return
      this.$set(target, payload.key, payload.value)
      const otherRef = fromSide === 'sx' ? this.$refs.OrderModelDx : this.$refs.OrderModelSx
      if (otherRef && otherRef.$refs.insole) {
        otherRef.$refs.insole.updateAfterload()
      }
    },
    checkInsoleModelsMaterials() {
      const syncKeys = ['insoleBaseMat', 'insoleBaseVar', 'insoleCoverMat', 'insoleCoverVar', 'insoleFillMat', 'insoleFillVar']
      const modSx = this.order.mod_sx ? this.order.mod_sx : {}
      const modDx = this.order.mod_dx ? this.order.mod_dx : {}
      return syncKeys.every(key => {
        const left = modSx[key] != null ? modSx[key] : null
        const right = modDx[key] != null ? modDx[key] : null
        return left === right
      })
    },
    changeShapeFilter(shapeId) {
      this.shapeFilter = shapeId
    },
    changeSecondaryPrev(bool) {
      this.hasSecondaryPrev = bool
    },
    changeSeasonFilter(val) {
      this.order.seasontag = val
    },
    updateChild() {
      this.$forceUpdate()
    },
    deleteOccurence(idtoerase) {
      this.$buefy.dialog.confirm({
        title: this.$translate('attention'),
        message: this.$translate('order_message_confirm'),
        cancelText: this.$translate('undo'),
        confirmText: this.$translate('order_message_destroy'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () =>
          this.$db
            .collection('orders')
            .doc(idtoerase)
            .set(
              {
                statusOrder: 'deletedord',
                deleted: true,
              },
              { merge: true }
            )
            .then(() => {
              this.lastSavedOrder = cloneDeep(this.order)
              this.$router.push({ name: 'orders' })
              this.$buefy.notification.open({
                duration: 3000,
                message: this.$translate('success_delete'),
              })
            }),
      })
    },
    trysave(newstatus) {
      if (this.canUserDoTransition(this.order.statusOrder, newstatus)) {
        this.order.statusOrder = newstatus
        this.validateBeforeSubmit()
      } else {
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('changeStatusNotPermitted'),
          type: 'is-danger',
        })
      }
    },
    tryvalidate() {
      this.$validator.validateAll().then(result => {
        this.$buefy.notification.open({
          duration: 3000,
          message: result ? this.$translate('success_form') : this.$translate('failed_form'),
          type: result ? 'is-success' : 'is-danger',
        })
      })
    },
    validateBeforeSubmit(simpleSave = false) {
      if (simpleSave) {
        this.$validator.validate('primaryCode').then(result => {
          if (result) {
            this.InitUpdate()
            return
          }
          this.$forceUpdate()
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('failed_form'),
            type: 'is-danger',
          })
        })
        return
      }
      if (this.order.pair === 'both' && !this.checkInsoleModelsMaterials()) {
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('insole_materials_mismatch'),
          type: 'is-danger',
        })
        return
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          if (
            this.order.statusOrder != 'compord' &&
            this.order.statusOrder != 'invord' &&
            this.order.send_date == null
          ) {
            this.order.send_date = new Date().getTime()
          }
          this.InitUpdate()
          return
        }
        this.$forceUpdate()
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('failed_form'),
          type: 'is-danger',
        })
      })
    },
    async InitUpdate() {
      this.isSaveDisabled = true
      if (this.order.mod_sx) {
        this.order.mod_sx.shoeType = this.order.shoeType
        this.order.mod_sx.catalogType = this.order.catalogType
      }
      if (this.order.mod_dx) {
        this.order.mod_dx.shoeType = this.order.shoeType
        this.order.mod_dx.catalogType = this.order.catalogType
      }
      this.order.searchArray = this.generateArrayFromOrder(this.order)
      this.nullifyUndefined(this.order)

      for (const item in this.order.attachment) {
        if (this.order.attachment[item]) {
          if (this.order.attachmentflag[item] === 0) {
            this.arraytoupload[item] = this.order.attachment[item]
          } else if (this.order.attachment[item].name) {
            this.arraytoupload[item] = this.order.attachment[item]
          }
        }
      }

      if (this.id === -1 && this.tempid === -1) {
        this.order.attachment = {}
        if (!this.order.statusOrder) this.order.statusOrder = 'compord'
        if (!this.order.primaryCode) this.order.primaryCode = 'draft'
        try {
          this.order.creationDate = new Date().getTime()
          const docRef = await this.$db.collection('orders').add(this.order)
          this.id = docRef.id
          this.order.id = docRef.id
        } catch (err) {
          this.$buefy.notification.open({ duration: 3000, message: err, type: 'is-danger' })
          this.isSaveDisabled = false
          return
        }
      } else if (this.id === -1) {
        this.id = this.tempid
      }

      let orderPath = `order/attachment/${this.order.id}`
      for (const item in this.arraytodelete) {
        await this.$storage.ref(`${orderPath}/${item}`).delete()
        this.order.attachment[item] = null
        this.order.attachmentflag[item] = null
      }
      this.arraytodelete = []

      for (const item in this.arraytoupload) {
        const storageRef = this.$storage.ref(`${orderPath}/${item}`)
        let fileUploaded = await storageRef.put(this.arraytoupload[item])
        let url = await fileUploaded.ref.getDownloadURL()
        this.order.attachment[item] = url
        this.order.attachmentflag[item] = 1
      }
      this.arraytoupload = []

      this.order.lastModificationDate = new Date().getTime()
      this.order.id = this.id
      this.order.deleted = this.order.statusOrder === 'deletedord'
      this.order.history = this.order.history ? this.order.history : []
      this.order.history.push({
        technician: this.$store.getters.user.userInfo.username,
        date: new Date().getTime(),
        oldStatus: this.currentStatus,
        newStatus: this.order.statusOrder,
      })

      var batch = this.$db.batch()
      var lookuppatients = this.$db.collection('patients').doc(this.order.patientId)
      batch.update(lookuppatients, {
        orders: firebase.firestore.FieldValue.arrayUnion(this.id),
      })
      var lookupshops = this.$db.collection('shops').doc(this.order.shopId)
      batch.update(lookupshops, {
        orders: firebase.firestore.FieldValue.arrayUnion(this.id),
      })
      var lookupcomp = this.$db.collection('companies').doc(this.order.companyId)
      batch.update(lookupcomp, {
        orders: firebase.firestore.FieldValue.arrayUnion(this.id),
      })
      var orderupdate = this.$db.collection('orders').doc(this.id)
      batch.update(orderupdate, this.order)
      batch
        .commit()
        .then(() => {
          this.currentStatus = this.order.statusOrder
          this.isSaveDisabled = false
          this.lastSavedOrder = cloneDeep(this.order)
          this.disabledbool = !this.isEditDoable(this.order.statusOrder)
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('order_saved'),
            type: 'is-success',
          })
        })
        .catch(() => {
          this.isSaveDisabled = false
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('error_form_server'),
            type: 'is-danger',
          })
        })
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!isEqual(this.order, this.lastSavedOrder)) {
      if (!window.confirm(this.$translate('confirm_exit_from_order'))) {
        return
      }
    }
    next()
  },
}
</script>
<style scoped>
.container >>> .field-label .label {
  text-align: left;
}
</style>
